import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const DIETARY_VENDOR_FIELDS = [
  {
    question: VENDORS.DIETARY_OUTSOURCED_COMPANY,
    title: 'Dietary outsourced company',
    invoiceFileTypeId: FILE_TYPES.DIETARY_OUTSOURCED_COMPANY_INVOICE,
    contractFileTypeId: FILE_TYPES.DIETARY_OUTSOURCED_COMPANY_CONTRACT,
  },
  {
    question: VENDORS.MAIN_FOOD_VENDOR,
    title: 'Main food supplier',
    invoiceFileTypeId: FILE_TYPES.MAIN_FOOD_SUPPLIER_INVOICE,
    contractFileTypeId: FILE_TYPES.MAIN_FOOD_SUPPLIER_CONTRACT,
  },
  {
    question: VENDORS.SECONDARY_FOOD_VENDOR,
    title: 'Secondary food supplier',
    invoiceFileTypeId: FILE_TYPES.SECONDARY_FOOD_SUPPLIER_INVOICE,
    contractFileTypeId: FILE_TYPES.SECONDARY_FOOD_SUPPLIER_CONTRACT,
  },
  {
    question: VENDORS.DAIRY_VENDOR,
    title: 'Dairy vendor',
    invoiceFileTypeId: FILE_TYPES.DAIRY_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.DAIRY_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.BREAD_VENDOR,
    title: 'Bread vendor',
    invoiceFileTypeId: FILE_TYPES.BREAD_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.BREAD_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.COFFEE_VENDOR,
    title: 'Coffee vendor',
    invoiceFileTypeId: FILE_TYPES.COFFEE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.COFFEE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.JUICE_VENDOR,
    title: 'Juice vendor',
    invoiceFileTypeId: FILE_TYPES.JUICE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.JUICE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.DIETARY_STAFFING_VENDOR,
    title: 'Dietary staffing vendor',
    invoiceFileTypeId: FILE_TYPES.DIETARY_STAFFING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.DIETARY_STAFFING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.OUTSOURCED_DIETICIAN_VENDOR,
    title: 'Outsourced dietician',
    invoiceFileTypeId: FILE_TYPES.OUTSOURCED_DIETICIAN_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.OUTSOURCED_DIETICIAN_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.DIETARY_EQUIPMENT_RENTAL_VENDOR,
    title: 'Dietary equipment rental vendor',
    invoiceFileTypeId: FILE_TYPES.DIETARY_EQUIPMENT_RENTAL_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.DIETARY_EQUIPMENT_RENTAL_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.DIETARY_SUPPLIES_VENDOR,
    title: 'Dietary supplies vendor',
    invoiceFileTypeId: FILE_TYPES.DIETARY_SUPPLIES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.DIETARY_SUPPLIES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MENU_TICKET_SYSTEM_VENDOR,
    title: 'Menu/ticket system',
    invoiceFileTypeId: FILE_TYPES.MENU_TICKET_SYSTEM_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MENU_TICKET_SYSTEM_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.DIETARY_CHEMICALS_VENDOR,
    title: 'Chemical provider',
    invoiceFileTypeId: FILE_TYPES.CHEMICAL_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.CHEMICAL_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.BAKERY_VENDOR,
    title: 'Bakery provider',
    invoiceFileTypeId: FILE_TYPES.BAKERY_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.BAKERY_PROVIDER_CONTRACT,
  },
];
